import { ProcessingAnimationDirective } from './infrastructure/directives/processing-animation.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AutosizeModule } from 'ngx-autosize';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MarkdownModule } from 'ngx-markdown';

import { AgentConversationComponent } from './components/agent-conversation.component';
import { ConversationMessageComponent } from './components/conversation-message/conversation-message.component';
import { ConversationParagraphsComponent } from './components/conversation-message/conversation-paragraphs/conversation-paragraphs.component';
import { ConversationFiltersComponent } from './components/partials/conversation-filters/conversation-filters.component';
import { ConversationDndComponent } from './components/partials/conversation-input/conversation-dnd/conversation-dnd.component';
import { ConversationInputComponent } from './components/partials/conversation-input/conversation-input.component';
import { InputFilePreviewComponent } from './components/partials/conversation-input/input-file-preview/input-file-preview.component';
import { SpeechRecognitionComponent } from './components/partials/conversation-input/speech-recognition/speech-recognition.component';
import { TalkingAvatarToggleComponent } from './components/partials/conversation-input/talking-avatar-toggle/talking-avatar-toggle.component';
import { ConversationInputDynamicComponent } from './components/partials/conversation-input-dynamic/conversation-input-dynamic.component';
import { CursorComponent } from './components/partials/cursor/cursor.component';
import { DynamicStatusComponent } from './components/partials/dynamic-status/dynamic-status.component';
import { ExportToSelectorComponent } from './components/partials/export-to-selector/export-to-selector.component';
import { SelectItemsToExportModalComponent } from './components/partials/export-to-selector/select-items-to-export-modal/select-items-to-export-modal.component';
import { TextFileExportModalComponent } from './components/partials/export-to-selector/text-file-export-modal/text-file-export-modal.component';
import { DocumentComponent } from './components/partials/file-preview-modal/drivers/document/document.component';
import { FilePreviewModalComponent } from './components/partials/file-preview-modal/file-preview-modal.component';
import { MaterialsPreviewComponent } from './components/partials/materials-preview/materials-preview.component';
import { FileDownloadComponent } from './components/partials/materials-preview/media-types/file-download/file-download.component';
import { ImagePreviewModalComponent } from './components/partials/materials-preview/media-types/image-viewer/image-preview-modal/image-preview-modal.component';
import { ImageViewerComponent } from './components/partials/materials-preview/media-types/image-viewer/image-viewer.component';
import { LinkComponent } from './components/partials/materials-preview/media-types/link/link.component';
import { StreamPlayerComponent } from './components/partials/materials-preview/media-types/stream-player/stream-player.component';
import { VideoPlayerComponent } from './components/partials/materials-preview/media-types/video-player/video-player.component';
import { YoutubePlayerComponent } from './components/partials/materials-preview/media-types/youtube-player/youtube-player.component';
import { CustomButtonComponent } from './components/partials/message-controls/custom-button/custom-button.component';
import { GoodPromptButtonComponent } from './components/partials/message-controls/good-prompt-button/good-prompt-button.component';
import { MessageControlsComponent } from './components/partials/message-controls/message-controls.component';
import { RetryButtonComponent } from './components/partials/message-controls/retry-button/retry-button.component';
import { ShowOriginalResourcesComponent } from './components/partials/message-controls/show-original-resources/show-original-resources.component';
import { StarButtonComponent } from './components/partials/message-controls/star-button/star-button.component';
import { OriginalContentComponent } from './components/partials/original-content/original-content.component';
import { SourceViewerSidebarComponent } from './components/partials/original-content/source-viewer-sidebar.component';
import { PreviewModalComponent } from './components/partials/preview-modal/preview-modal.component';
import { PromptHintsDropdownComponent } from './components/partials/prompt-hints-dropdown/prompt-hints-dropdown.component';
import { PromptHintsMenuComponent } from './components/partials/prompt-hints-menu/prompt-hints-menu.component';
import { BotQuizAnswersComponent } from './components/partials/quiz/bot-quiz-answers.component';
import { QuizReferenceComponent } from './components/partials/quiz-reference/quiz-reference.component';
import { RefProgressComponent } from './components/partials/references/ref-progress/ref-progress.component';
import { ReferencesComponent } from './components/partials/references/references.component';
import { SourcePreviewModalComponent } from './components/partials/source-preview/modal/source-preview-modal.component';
import { NewSourcePreviewButtonComponent } from './components/partials/source-preview/new-button/new-source-preview-button.component';
import { SourceSearchModalComponent } from './components/partials/source-search-modal/source-search-modal.component';
import { TypingIndicatorComponent } from './components/partials/typing-indicator/typing-indicator.component';
import { WelcomeMessageComponent } from './components/partials/welcome-message/welcome-message.component';
import { LocalSourcesModule } from '@shared/components/local-sources/local-sources.module';

import { MaterialModule } from '../../material.module';
import { LayoutModule } from '../layout/layout.module';
import { AutoScrollDirective } from './infrastructure/directives/auto-scroll.directive';
import { ReferenceInjectDirective } from './infrastructure/directives/reference-inject.directive';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatIconModule,
    MaterialModule,
    AutosizeModule,
    ReactiveFormsModule,
    LocalSourcesModule,
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    FormsModule,
    LayoutModule,
    MarkdownModule,
    SourceSearchModalComponent,
    AgentConversationComponent,
    InputFilePreviewComponent,
    ConversationInputComponent,
    DynamicStatusComponent,
    ConversationDndComponent,
    PromptHintsMenuComponent,
    PromptHintsDropdownComponent,
    SpeechRecognitionComponent,
    TalkingAvatarToggleComponent,
    ConversationFiltersComponent,
    CustomButtonComponent,
    PreviewModalComponent,
    QuizReferenceComponent,
    MaterialsPreviewComponent,
    SourcePreviewModalComponent,
    StreamPlayerComponent,
    VideoPlayerComponent,
    ImageViewerComponent,
    YoutubePlayerComponent,
    ImagePreviewModalComponent,
    FileDownloadComponent,
    LinkComponent,
    FilePreviewModalComponent,
    DocumentComponent,
    ConversationMessageComponent,
    MessageControlsComponent,
    ShowOriginalResourcesComponent,
    StarButtonComponent,
    GoodPromptButtonComponent,
    RetryButtonComponent,
    OriginalContentComponent,
    SourceViewerSidebarComponent,
    ReferencesComponent,
    CustomButtonComponent,
    ConversationParagraphsComponent,
    NewSourcePreviewButtonComponent,
    ExportToSelectorComponent,
    SelectItemsToExportModalComponent,
    TextFileExportModalComponent,
    BotQuizAnswersComponent,
    ReferenceInjectDirective,
    WelcomeMessageComponent,
    AutoScrollDirective,
    CursorComponent,
    ProcessingAnimationDirective,
    ConversationFiltersComponent,
    RefProgressComponent,

    TypingIndicatorComponent,
    ConversationInputDynamicComponent,
  ],
  exports: [
    InputFilePreviewComponent,
    ConversationInputComponent,
    DynamicStatusComponent,
    AgentConversationComponent,
    PreviewModalComponent,
    MaterialsPreviewComponent,
    SourcePreviewModalComponent,
    FilePreviewModalComponent,
    StreamPlayerComponent,
    MessageControlsComponent,
    StarButtonComponent,
    OriginalContentComponent,
    CustomButtonComponent,
    WelcomeMessageComponent,
    ConversationFiltersComponent,
    TypingIndicatorComponent,
  ],
})
export class ConversationModule {}
